import {Link, Li, ContextMenu, Button, Icon, Dialog, Loading} from 'startlibs/lib/components'
import {getColor} from 'startlibs/lib/lib'
import {withToggles, withRouteTo, fetchConnect, withPopupToggles} from 'startlibs/lib/hocs'
import {getFetcher, postFetcher} from 'startlibs'
import {ice} from 'icepath'
import {
  daysLeft,
  formatCurrency, getPlanType,
  normalizeSubscription,
  stripeIntervalToAbbreviation,
  stripeIntervalToInterval,
  toPrice
} from '../lib'
import {CreditCardWrapper, ServicesOfferingWrapper} from '../checkout/CheckoutComponents'
import {cancelSubscription} from '../reducers'
import {connect} from 'react-redux'
import React from 'react'
import styled from 'styled-components'
import {en_US, formatDate} from 'report-components'
import {executeCaptcha, RecaptchaBrandingText, waitCaptcha} from "../checkout/CaptchaUtils";

const PLAN_STATUS_LABEL = {
  active: 'Active',
  trialing: 'Trial',
  canceled: 'Canceled',
  canceled_renewal: 'Canceled renewal',
  past_due: 'Pending',
  unpaid: 'Canceled'
}

const PLAN_STATUS_COLOR = {
  active: 'main',
  trialing: 'main',
  canceled: 'alert',
  canceled_renewal: 'alert',
  past_due: 'warning',
  unpaid: 'alert'
}

const FOOTER_COLOR = {
  ...PLAN_STATUS_COLOR,
  active: 'gray240',
  trialing: 'gray240'
}

const StatusLabel = styled.div`
  background-color: ${props => getColor(PLAN_STATUS_COLOR[props.status])(props)};
  color: white;
  display: inline-block;
  line-height: 18px;
  padding: 1px 5px;
  border-radius: 3px;
  font-weight: 600;
  font-size: 13px;
  display: inline-block;
  margin-left: 0.5rem;
  @media (max-width: 560px) {
    font-size: 12px;
    vertical-align: 1px;
  }
`

const SubscriptionDetailsCard = styled.div`
  &.card.with-icon.large-icon {
    border: 1px solid ${props => props.selected ? getColor('main') : getColor('gray210') };
    margin-bottom: 1rem;
    & ~ .card.with-icon.large-icon {
      margin-top: 0;
    }
    .card-detail {
      ul {
        color: ${getColor('gray150')};
        margin-bottom: 0;
        font-size: 12px;
        li {
          margin-bottom: 0;
        }
      }
    }
    .card-content {
      padding-left: 9.5rem;
      display: flex;
      min-height: 9.5rem;
    }
    .card-icon {
      width: 7.5rem;
      height: 7.5rem;
      text-align: center;
      background: rgba(0,0,0,0.05);
      img {
        max-width: 100%;
        padding: 1rem;
      }
    }
  }
  .subscription-details {
    flex-grow: 1;
    .additional-info {
      font-size: 11px;
      margin-top: .25rem;
      color: ${getColor('gray180')};
    }
  }
  .change-plan {
    margin-top: .5rem;
    width: 100%;
  }
  .plan-box {
    padding: 0.5rem;
    display: block;
    border-radius: 5px;
    border: 1px solid rgba(0,0,0,0.1);
    position: relative;
    .plan-price {
      line-height: 1;
      font-weight: 600;
      font-size: 13px;
      color: ${getColor('gray90')};
      margin-bottom: 3px;
    }
    .plan-detail {
      color: ${getColor('gray150')};
      font-size: 11px;
    }
  }
  @media (max-width: 600px) {
    .card-icon {
      display: none !important;
    }
    .card-content {
      padding: 1rem !important;
    }
    .plans-wrapper {
      margin-left: 1rem;
    }
  }
  @media (max-width: 510px) {
    .card-content {
      flex-wrap: wrap;
    }
    .plans-wrapper {
      max-width: 100%;
      flex-basis: 100%;
      margin-top: 1rem;
      margin-left: 0;
      display: flex;
    }
    .plan-box ~ .plan-box {
      margin-left: .5rem;
      margin-top: 0;
    }
    .change-plan {
      margin-left: .5rem;
      margin-top: 0;
      width: inherit;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`

const SubscriptionDetailsFooter = styled.div`
  color: ${props => FOOTER_COLOR[props.status] === 'gray240' ? getColor('gray120')(props) : 'white'} ;
  background: ${props => getColor(FOOTER_COLOR[props.status])(props)};
  padding: 0.25rem 1rem 1rem;
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  justify-content: space-between;
  .billing-detail {
    margin-right: 1rem;
    margin: 0.75rem 1rem 0 0;
  }
  .billing-history-link {
    cursor: pointer;
    margin: 0.75rem 0 0;
    ${Icon} {
      font-size: 20px;
      margin-right: 0.5rem;
      line-height: 0;
      vertical-align: -4px;
    }
  }
  a {
    text-decoration: underline;
  }
  .payment-failure-details {
    flex-basis: 100%;
    margin-top: 0.75rem;
    padding: .5rem .75rem;
    background-color: rgba(255,255,255,0.2);
    border-radius: 4px;
  }
  @media (max-width: 605px) {
    .billing-history-link {
      order: 3;
    }
  }
`

const CreditCardDetailsCard = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  min-height: 5.25rem;
  &.card {
    padding: 1rem 1.5rem;
  }
  .credit-card-number {
    font-size: 14px;
    margin: 0.5rem 1rem 0.5rem 0;
    color: ${getColor('gray90')};
    flex-shrink: 0;
    span {
      font-size: 18px;
      vertical-align: -2px;
    }
  }
  ${Button} {
    margin: 0.5rem 0;
  }
`

const CreditCardIcon = styled.img`
  width: 29px;
  margin-right: 1rem;
  vertical-align: text-bottom;
  display: inline-block;
`

const BillingHistoryDialog = styled(Dialog)`
  max-height: 100%;
  ${Dialog.Content} {
    display: flex;
    flex-direction: column;
  }
  ${Dialog.Footer} {
    flex-shrink: 0;
  }
  .box {
    min-height: 25rem;
    margin-bottom: 1rem;
    padding: 0;
    overflow: hidden;
    display: flex;
    position: relative;
  }
  .table-container {
    overflow: auto;
    width: 100%
  }
  table {
    width: 100%;
    border-spacing: 0;
    padding: 0.25rem 0.5rem;
    th, td {
      padding: 0.75rem;
      text-align: left;
      border-bottom: 1px solid ${getColor('gray210')};
    }
    tr:last-child td {
      border-bottom: none;
    }
  }
  p:last-child {
    margin-bottom: 0;
  }
`
export const PlanDetails = styled.ul`
  margin-bottom: 0.5rem;
  color: ${getColor('gray90')};
  font-size: 13px;
  flex-grow: 1;
  li {
    margin-bottom: 0.5rem;
  }
`

const ResourcesUsageCardWrapper = styled.div`
  margin-top: 2rem;
  .card {
    padding: 1.5rem;
  }
  h4 {
    font-size: 14px;
    margin-bottom: 0.25rem;
    span {
      font-weight: 400;
      font-size: 12px;
      display: inline-block;
      color: rgba(0,0,0,0.5);
    }
  }
  .upgrade-cta {
    font-size: 12px;
  }
`

const DialogContentLoading = styled.div`
`

const ProgressBar = styled.div`
  height: 1rem;
  width: 100%;
  border-radius: 30px;
  background-color: rgba(0,0,0,0.075);
  margin: 0.25rem 0 .75rem;
  display: inline-block;
  overflow: hidden;
  :after {
    content: '';
    width: ${props => props.progress || 0}%;
    height: 100%;
    min-width: 4px;
    display: block;
    border-radius: 30px;
    background-color: ${getColor('main')};
  }
`
const PlanActionsContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;
  ${Button} {
    flex-grow: 1;
  }
`

const DropdownButton = Button.extend`
  width: 2rem;
  padding: 0;
  margin-left: 0.5rem !important;
  span {
    transform: translate(50%,-50%);
    right: 50%;
  }
`

export const STORAGE_PLAN_TYPE_DETAILS = {
  'STORAGE_STANDARD': (extra) => <PlanDetails>
    {extra}
    <li>Ideal for animal studies or anonymized human studies</li>
  </PlanDetails>,
  'STORAGE_PRO': (extra) => <PlanDetails>
    {extra}
    <li>Ideal for studies that contain protected health information (PHI)</li>
    <li>Includes free software VPN to secure data in transit</li>
  </PlanDetails>
}

export const PLAN_TYPE_DETAILS = {
  ...STORAGE_PLAN_TYPE_DETAILS,
  'REPORT_BASIC': () => <PlanDetails>
    <li>Create up to <b>50 reports</b> per month.</li>
    <li>Download and share reports in PDF format.</li>
    <li>Historical reports storage.</li>
  </PlanDetails>,
  'REPORT_BASIC_V2': () => <PlanDetails>
    <li>Not able to create new reports.</li>
    <li>Download and share reports in PDF format.</li>
    <li>Historical reports storage.</li>
    <li>Includes report key images.</li>
    <li>Not able to make new study shares.</li>
  </PlanDetails>,
  'REPORT_BASIC_V3': () => <PlanDetails>
    <li>Create up to <b>5 reports</b> per month.</li>
    <li>Download and share reports in PDF format.</li>
    <li>Historical reports storage.</li>
    <li>Includes report key images.</li>
    <li><b>5 study shares</b> per month.</li>
  </PlanDetails>,
  'REPORT_STANDARD': () => <PlanDetails>
    <li>Create up to <b>50 reports</b> per month.</li>
    <li>Download and share reports in PDF format.</li>
    <li>Historical reports storage.</li>
    <li>Includes report key images.</li>
  </PlanDetails>,
  'REPORT_STANDARD_V2': () => <PlanDetails>
    <li>Create up to <b>25 reports</b> per month.</li>
    <li>Download and share reports in PDF format.</li>
    <li>Historical reports storage.</li>
    <li>Includes report key images.</li>
    <li><b>25 study shares</b> per month.</li>
  </PlanDetails>,
  'REPORT_PRO': () => <PlanDetails>
    <li>Create <b>unlimited reports</b> per month.</li>
    <li>Download and share reports in PDF format.</li>
    <li>Historical reports storage.</li>
    <li>Includes report key images.</li>
    <li><b>Unlimited study shares</b> per month.</li>
  </PlanDetails>
}

export const SubscriptionDetailsCardComponent = ({children, extraPlanDetails, planType, status, details, plans, isBilling, isStorage, ...props}) =>
  <SubscriptionDetailsCard
    className="card with-icon large-icon"
    {...props}
  >
    <div className="card-content">
      <div className="card-icon"><img src={isStorage ? '/public/storage-plan.png' : '/public/report-plan.png'}
                                      alt="Plan Icon"/></div>
      <div className="subscription-details">
        <div className="card-title">
          {getPlanType(planType)} plan
          {status && <StatusLabel status={status}>{PLAN_STATUS_LABEL[status]}</StatusLabel>}
        </div>
        <div className="card-detail">
          {
            details || PLAN_TYPE_DETAILS[planType](extraPlanDetails)
          }
        </div>
      </div>
      <div className="plans-wrapper">
        {plans}
      </div>
    </div>
    {children}
  </SubscriptionDetailsCard>

export const getCancelDate = (subscriptionEnd, daysUntilCancel) => new Date((subscriptionEnd * 1000) + (daysUntilCancel * 1000 * 60 * 60 * 24))

const PastDueFooter = withToggles('details')(({subscription, billingLink, details, daysUntilCancel, paymentErrorDetail}) =>
  <React.Fragment>
    <div className="billing-detail">Subscription will be canceled on <FormattedDate
      date={getCancelDate(subscription.currentPeriodEnd, daysUntilCancel)} format="LL dd"/> unless
      normalized. {paymentErrorDetail &&
      <a onClick={details.toggle}>{details.isOpen ? 'Hide details' : 'See details'}</a>}</div>
    {billingLink}
    {
      details.isOpen &&
      <div className="payment-failure-details">
        {paymentErrorDetail}
      </div>
    }
  </React.Fragment>)


const PlanStatus = withPopupToggles('popup')(({popup, checkoutUrl, checkoutLabel, openCancelSubscriptionDialog, status, plan}) =>
  <React.Fragment>
    <div className="plan-box static">
      {
        plan.amount === 0 ? <div className="plan-price">Free</div> :
        <div className="plan-price">
          ${plan ? toPrice(plan.amount) : 'undefined'} USD / {plan ? stripeIntervalToAbbreviation(plan.interval) : 'mo'}
        </div>
      }
      {
        plan.amount === 0 ? null :
        !status || status === 'active' || status === 'past_due' ?
        <React.Fragment>
          <div className="plan-detail">billed {stripeIntervalToInterval(plan.interval)}</div>
        </React.Fragment> :
        <React.Fragment>
          <div className="plan-detail">billing canceled</div>
        </React.Fragment>
      }
    </div>
    {
      <PlanActionsContainer>
        {
          checkoutLabel &&
          <Button.Link small to={checkoutUrl}>{checkoutLabel}</Button.Link>
        }
        {
          plan.name !== 'REPORT_BASIC_V2' && status !== 'canceled' && status !== 'canceled_renewal' &&
          <DropdownButton small withDropdown onClick={popup.open}>
            {
              popup.isOpen &&
              <ContextMenu>
                <Li
                  label="Cancel subscription"
                  onClick={openCancelSubscriptionDialog}
                />
              </ContextMenu>
            }
          </DropdownButton>
        }
      </PlanActionsContainer>
    }
  </React.Fragment>
)

const CARD_BRANDS_ICONS = {
  'American Express': 'amex',
  'Diners Club': 'diners',
  'Discover': 'discover',
  'JCB': 'jcb',
  'MasterCard': 'mastercard',
  'UnionPay': 'unionpay',
  'Visa': 'visa'
}

export const CreditCardDetails = ({children, card}) => <CreditCardDetailsCard className="card">
  <div className="credit-card-number">
    <CreditCardIcon
      src={`/public/icon/${CARD_BRANDS_ICONS[card.brand] || 'unknown'}.svg`}/><span>•••• •••• •••• </span> {card.last4}
  </div>
  {children}
</CreditCardDetailsCard>

export const FormattedDate = ({date, format}) => formatDate(new Date(date), en_US, format || 'L dd, yyyy')


const CANCELED_SUBSCRIPTION = {
  status: 'canceled'
}

@withRouteTo
@withToggles('billingHistoryDialog', 'cancelSubscriptionDialog', 'loadingLimits')
@fetchConnect((state) => ({
  user: state.user
}), undefined, 'stripe')
export class Billing extends React.PureComponent {

  state = {
    storageSubscription: ice.get(this.props.stripe, ['customer', 'subscriptions', 'data']).find(_ => _.metadata && _.metadata.type === 'STORAGE'),
    reportSubscription: ice.get(this.props.stripe, ['customer', 'subscriptions', 'data']).find(_ => _.metadata && (!_.metadata.type || _.metadata.type === 'REPORT'))
  }

  componentDidUpdate(prevProps) {
    if (this.props.stripe !== prevProps.stripe) {
      this.setState({
        storageSubscription: ice.get(this.props.stripe, ['customer', 'subscriptions', 'data']).find(_ => _.metadata && _.metadata.type === 'STORAGE'),
        reportSubscription: ice.get(this.props.stripe, ['customer', 'subscriptions', 'data']).find(_ => _.metadata && (!_.metadata.type || _.metadata.type === 'REPORT'))
      })
    }
  }

  componentDidMount() {
    if (!this.state.reportSubscription) return this.props.routeTo('/')
    if (this.state.reportSubscription && this.state.reportSubscription.status === 'active') {
      this.props.loadingLimits.open()
      getFetcher('/api/account/limits')
        .then((limits) => {
          this.setState({limits})
          this.props.loadingLimits.close()
        })
        .catch(() => this.props.loadingLimits.close())
    }
  }

  getStoragePlanName = () => {
    const subItems = this.state.storageSubscription.subscriptionItems.data
    const subItemsId = subItems.map(_ => _.plan.id)
    const currentPlan = this.props.stripe.storagePlans.plans.find(_ => subItemsId.indexOf(_.id) >= 0)
    const currentPlanType = currentPlan.name.split('_').slice(0, 2).join('_')
    return getPlanType(currentPlanType)
  }

  getReportPlanName = () => {
    const subscription = this.state.reportSubscription
    const currentPlanInfo = (subscription.plan && [...this.props.stripe.stripePlans.plans,...this.props.stripe.replacedPlans.plans].find(_ => _.id === subscription.plan.id))
    return getPlanType(currentPlanInfo.name)
  }

  render() {
    if (!this.state.reportSubscription) {return <Loading absolute size={40} borderWidth={6}/>}

    const {refreshFetchedState, loadingLimits, stripe: {customer: {sources}, daysUntilCancel, paymentErrorDetail, replacedPlans: {plans: replacedPlans}, stripePlans: {plans}, storagePlans, vpnstationPrice, vpnstationPriceYear}, billingHistoryDialog, cancelSubscriptionDialog} = this.props
    const {limits} = this.state
    const allStripePlans = [...plans,...replacedPlans]
    const card = sources && sources.data && sources.data[0]
    const reportSubscription = this.state.reportSubscription || CANCELED_SUBSCRIPTION
    const subscription = normalizeSubscription(reportSubscription, card)

    const currentPlanInfo = (subscription.plan && allStripePlans.find(_ => _.id === subscription.plan.id))
    const currentPlanType = (currentPlanInfo && currentPlanInfo.name) || 'REPORT'

    const viewBillingHistoryLink = <span className="billing-history-link" onClick={billingHistoryDialog.open}><Icon
      icon="note"/><a>View billing history</a></span>
    return <div className="content edit-profile">
      <div><Button.Link className="return-home-button" icon="arrow-left" to="/">Home</Button.Link></div>
      <div className="profile-header">
        <h1>Horos Cloud billing</h1>
      </div>
      <p>Check your current subscription and billing details below:</p>
      <SubscriptionDetailsCardComponent
        isBilling
        status={subscription.status}
        planType={currentPlanType}
        plans={
          <PlanStatus
            checkoutUrl="/checkout?of=plan"
            plan={currentPlanInfo || subscription.plan}
            checkoutLabel={(currentPlanInfo || subscription.plan) === 'REPORT_BASIC_V2' ? 'Upgrade' : 'Change plan'}
            status={subscription.status}
            openCancelSubscriptionDialog={cancelSubscriptionDialog.open}
          />
        }
      >
        <SubscriptionDetailsFooter status={subscription.status}>
          {
            subscription.status === 'active' ?
            <React.Fragment>
              <div className="billing-detail">Subscribed since <FormattedDate
                date={subscription.created * 1000}/>. {reportSubscription.status === 'trialing' && daysLeft(reportSubscription.trialEnd * 1000) > 0 && `You have ${daysLeft(reportSubscription.trialEnd * 1000)} free days remaining before first payment.`}
              </div>
              {viewBillingHistoryLink}
            </React.Fragment> :
            subscription.status === 'canceled' || subscription.status === 'unpaid' ?
            <React.Fragment>
              {subscription.canceledAt ?
               <div className="billing-detail">Subscription canceled on <FormattedDate
                 date={subscription.canceledAt * 1000}/>.</div> :
               <div className="billing-detail">This subscription has been canceled.</div>
              }
              {viewBillingHistoryLink}
            </React.Fragment> :
            subscription.status === 'canceled_renewal' ?
            <React.Fragment>
              <div className="billing-detail">Subscription service will be interrupted on <FormattedDate
                date={subscription.currentPeriodEnd * 1000}/>.
              </div>
              {viewBillingHistoryLink}
            </React.Fragment> :
            subscription.status === 'past_due' ?
            <PastDueFooter billingLink={viewBillingHistoryLink} subscription={subscription}
                           daysUntilCancel={daysUntilCancel} paymentErrorDetail={paymentErrorDetail}/> :
            ' '
          }
        </SubscriptionDetailsFooter>
      </SubscriptionDetailsCardComponent>

      {
        this.state.storageSubscription &&
        <StorageSubscriptionDetails
          openCancelSubscriptionDialog={() => cancelSubscriptionDialog.open('STORAGE')}
          subscription={normalizeSubscription(this.state.storageSubscription, card)}
          plans={storagePlans.plans}
          vpnPrices={{month: vpnstationPrice, year: vpnstationPriceYear}}
        />
      }

      {
        limits && limits.currentPlanReportLimits >= 0 &&
        <ResourcesUsageCardWrapper>
          <h3>Resources usage</h3>
          <div className="card">
            <h4>Reports <span>({limits.currentReports} of {limits.currentPlanReportLimits} used this month)</span></h4>
            <ProgressBar progress={limits.currentReports / limits.currentPlanReportLimits * 100}/>
            <h4>Study sharing <span>({limits.currentShares} of {limits.currentPlanShareLimits} used this month)</span>
            </h4>
            <ProgressBar progress={limits.currentShares / limits.currentPlanShareLimits * 100}/>
            <div className="upgrade-cta">Need more reports or sharing limits per month? <Link to="/checkout?of=plan"
                                                                                              class="link">Upgrade your
              plan now</Link>.
            </div>
          </div>
        </ResourcesUsageCardWrapper>
      }
      {
        loadingLimits.isOpen && <div></div>
      }
      {card && <CreditCardWrapper>
        <React.Fragment>
          <h3>Credit card details</h3>
          <CreditCardDetails card={card}>
            <Button.Link small skipTo="/card-update">Change credit card</Button.Link>
          </CreditCardDetails>
        </React.Fragment>
      </CreditCardWrapper>}

      {
        false && !this.state.storageSubscription && <React.Fragment>
          <hr/>
          <ServicesOfferingWrapper>
            <div className="card">
              <img src="/public/storage-plan-220x220.png" alt="Plan Icon"/>
              <h4>Would you like to store and have access to your image studies using the cloud?</h4>
              <p>Securely store and easily access medical imaging studies in your Horos Cloud.<br/>You can access them
                when and where you need to.</p>
              <Button.Link highlight to="/storage/checkout?of=plan">Check our plans</Button.Link>
              <Button.a target="_blank" href="https://horosproject.org/cloud-access-pricing/" outline>Learn more</Button.a>
            </div>
          </ServicesOfferingWrapper>
        </React.Fragment>
      }

      {
        cancelSubscriptionDialog.isOpen === true &&
        <CancelSubscriptionDialog
          currentCard={card}
          stripePlanId={allStripePlans.find(_ => _.name === 'REPORT_BASIC_V2').id}
          planName={this.getReportPlanName()}
          refreshFetchedState={refreshFetchedState}
          subscriptionType="REPORT"
          closeDialog={cancelSubscriptionDialog.close}
        />
      }
      {
        cancelSubscriptionDialog.isOpen === 'STORAGE' &&
        <CancelSubscriptionDialog
          planName={this.getStoragePlanName()}
          isStorage
          refreshFetchedState={refreshFetchedState}
          subscriptionType="STORAGE"
          closeDialog={cancelSubscriptionDialog.close}
        />
      }
      {billingHistoryDialog.isOpen && <BillingHistoryDialogComponent closeDialog={billingHistoryDialog.close}/>}
    </div>
  }

}

const StorageSubscriptionDetails = ({openCancelSubscriptionDialog, subscription, plans, viewBillingHistoryLink, daysUntilCancel, paymentErrorDetail, vpnPrices}) => {
  const subItems = subscription.subscriptionItems.data
  const subItemsId = subItems.map(_ => _.plan.id)
  const currentPlan = plans.find(_ => subItemsId.indexOf(_.id) >= 0)
  const currentPlanType = currentPlan.name.split('_').slice(0, 2).join('_')
  const vpnItem = subItems.find(_ => _.plan.id !== currentPlan.id) || {quantity:0}

  const vpnCost = currentPlanType === 'STORAGE_PRO' ? (vpnPrices[currentPlan.interval] * Math.max(0, vpnItem.quantity - 1)) : 0
  const currentPlanWithStations = {...currentPlan, amount: currentPlan.amount + vpnCost, status: 'active'}

  const volume = currentPlan.name.split('_')[2]
  return <SubscriptionDetailsCardComponent
    isStorage
    isBilling
    status={subscription.status}
    planType={currentPlanType}
    extraPlanDetails={
      <React.Fragment>
        <li><b>{volume} studies/month storage</b></li>
        {currentPlanType === 'STORAGE_PRO' && <li><b>{vpnItem.quantity} workstation(s) access</b></li>}
      </React.Fragment>
    }
    plans={
      <PlanStatus
        checkoutUrl="/storage/checkout?of=plan"
        checkoutLabel={(subscription.status === 'active' || subscription.status === 'past_due') ? 'Change plan' : 'Reactivate'}
        plan={currentPlanWithStations}
        openCancelSubscriptionDialog={openCancelSubscriptionDialog}
        status={subscription.status}
      />
    }
  >
    <SubscriptionDetailsFooter status={subscription.status}>
      {
        subscription.status === 'active'
        ? <React.Fragment>
          <div className="billing-detail">
            Subscribed since <FormattedDate date={subscription.created * 1000}/>.
          </div>
          {viewBillingHistoryLink}
        </React.Fragment>
        : subscription.status === 'canceled' || subscription.status === 'unpaid'
          ? <React.Fragment>
            {
              subscription.canceledAt
              ? <div className="billing-detail">
                Subscription canceled on
                <FormattedDate date={subscription.canceledAt * 1000}/>.
              </div>
              : <div className="billing-detail">This subscription has been canceled.</div>
            }
            {viewBillingHistoryLink}
          </React.Fragment> :
          subscription.status === 'canceled_renewal'
          ? <React.Fragment>
            <div className="billing-detail">Subscription service will be interrupted on <FormattedDate
              date={subscription.currentPeriodEnd * 1000}/>.
            </div>
            {viewBillingHistoryLink}
          </React.Fragment>
          : subscription.status === 'past_due'
            ? <PastDueFooter
              billingLink={viewBillingHistoryLink}
              subscription={subscription}
              daysUntilCancel={daysUntilCancel}
              paymentErrorDetail={paymentErrorDetail}/>
            : ' '
      }
    </SubscriptionDetailsFooter>
  </SubscriptionDetailsCardComponent>
}

@withRouteTo
@withToggles('isLoading')
@connect(undefined, {cancelSubscription})
class CancelSubscriptionDialog extends React.Component {

  captchaRef = {current:null}

  cancelSubscriptionWithCaptcha = () => {
    waitCaptcha((token) => {
      this.handleCaptchaCallback(token)
    },this.captchaRef).then(() => {
      executeCaptcha({})
    })
  }
  handleCaptchaCallback = (captchaToken) => {
    postFetcher('/api/update-subscription', {
        stripeCardToken: this.props.currentCard.id,
        stripePlanId: this.props.stripePlanId,
        captchaToken
      }, {method: 'PUT'}
    ).then(() => this.props.routeTo('/billing', true))
      .then(this.props.refreshFetchedState)
      .then(this.props.closeDialog)
  }

  cancelSubscription = () => {
    this.props.isLoading.open();
    if (this.props.subscriptionType === 'REPORT') {
      return this.cancelSubscriptionWithCaptcha()
    } else {
      return this.props.cancelSubscription(this.props.subscriptionType)
        .then(() => this.props.routeTo('/billing', true))
        .then(this.props.refreshFetchedState)
        .then(this.props.closeDialog)
    }
  }

  render() {
    const {planName, closeDialog, isLoading, isStorage} = this.props
    return <Dialog
      closeDialog={closeDialog}
      title={`Confirm ${planName} cancelation?`}
    >
      <Dialog.Content icon="warning">
        {isStorage ? <div>
        <p>By canceling your {planName} subscription you <strong>won’t be able to store new studies</strong>.</p>
        <p>We do not guarantee storage or access to studies unless you have an active subscription.</p>
        </div>
        :
        <div>
          <p>By canceling your {planName} subscription, you will not be able to edit reports or create new ones.</p>
          <p>Access to reports already created will be available, but in read-only mode, unless you create a new subscription.</p>
        </div>}
        <p><strong>Do you want to cancel your subscription?</strong></p>
      </Dialog.Content>
      <Dialog.Footer>
        <Button onClick={closeDialog}>Close</Button>
        <Button alert isLoading={isLoading.isOpen} onClick={this.cancelSubscription}>Cancel subscription</Button>
      </Dialog.Footer>
      <div
        ref={(el) => this.captchaRef.current = el}
        className="g-recaptcha"
      />
      <RecaptchaBrandingText>
        This site is protected by reCAPTCHA and the Google <a
        href="https://policies.google.com/privacy"
        rel="noopener noreferrer"
        target="_blank"
      >
        Privacy Policy</a> and <a
        href="https://policies.google.com/terms"
        rel="noopener noreferrer"
        target="_blank"
      >Terms of Service</a> apply.
      </RecaptchaBrandingText>
    </Dialog>
  }
}

class BillingHistoryDialogComponent extends React.Component {

  state = {invoices: null}

  componentDidMount() {
    getFetcher('/api/stripe-invoices')
      .then(({data}) => this.setState({invoices: data}))
  }

  render() {
    const {invoices} = this.state
    const {closeDialog} = this.props
    return <BillingHistoryDialog
      closeDialog={closeDialog}
      title="Billing history"
    >
      <Dialog.Content>
        <p>All successful and failed payment attempts listed below:</p>
        <div className="box">
          {invoices ?
           <div className="table-container">
             <table>
               <thead>
               <tr>
                 <th>Date</th>
                 <th>Period</th>
                 <th>Amount</th>
                 <th>Status</th>
               </tr>
               </thead>
               <tbody>
               {invoices.map(invoice =>
                 <tr key={invoice.id}>
                   <td><FormattedDate date={invoice.date * 1000}/></td>
                   <td><FormattedDate date={invoice.periodStart * 1000} format="L dd"/> - <FormattedDate
                     date={invoice.periodEnd * 1000} format="L dd, yyyy"/></td>
                   <td>{invoice.currency.toUpperCase()} {formatCurrency(invoice.total)}</td>
                   <td>{!invoice.attempted ? 'Not Attempted' : invoice.paid ? 'Successful' : 'Failure'}</td>
                 </tr>
               )}
               </tbody>
             </table>
           </div>
                    :
           <DialogContentLoading><Loading absolute size={40} borderWidth={6}/></DialogContentLoading>
          }
        </div>
        <p>Need help with any issue regarding payments? Reach out to our <a className="link"
                                                                            href="mailto:support@horosproject.org">support
          team</a>.</p>
      </Dialog.Content>
      <Dialog.Footer>
        <Button onClick={closeDialog}>Close</Button>
      </Dialog.Footer>
    </BillingHistoryDialog>
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/user/Billing.jsx